import React from 'react';

/**
 * Shared dropdown list for searchable selects (e.g. product picker, category picker).
 * @param {Array} options - List of items
 * @param {string} emptyMessage - Shown when options.length === 0
 * @param {function} onSelect - (item) => void
 * @param {function} getLabel - (item) => string
 * @param {string} id - For aria-controls
 * @param {function} [getItemKey] - (item, index) => string|number for list key; default (item, i) => item?.id ?? i
 */
const SearchableDropdown = ({
  options,
  emptyMessage,
  onSelect,
  getLabel,
  id,
  getItemKey = (item, i) => (item?.id != null ? String(item.id) : String(i))
}) => (
  <ul
    className="list-group position-absolute w-100 mt-1"
    style={{ maxHeight: '200px', overflowY: 'auto', zIndex: 10 }}
    role="listbox"
    id={id}
  >
    {options.length === 0 ? (
      <li className="list-group-item list-group-item-secondary" role="option">
        {emptyMessage}
      </li>
    ) : (
      options.map((item, i) => (
        <li
          key={getItemKey(item, i)}
          role="option"
          tabIndex={0}
          className="list-group-item list-group-item-action"
          onClick={() => onSelect(item)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onSelect(item);
            }
          }}
        >
          {getLabel(item)}
        </li>
      ))
    )}
  </ul>
);

export default SearchableDropdown;
